import React from 'react'

export default _ =>
  <svg width='36' height='67' xmlns='http://www.w3.org/2000/svg'>
    <path d='M34.5 65.32L2.68 33.5 34.5 1.68' stroke='currentColor' strokeWidth='3' fill='none' fillRule='evenodd' />
  </svg>
